import * as Logger from './logger.js'
import * as Utils from './utils.js';
import { HSCard } from './card.js';
import { UserSession } from './session.js';
import styles from './metric.css';
import template from './metric.html';
import callsImg from './img/call.svg';
import tasksImg from './img/task.svg';
import mediaImg from './img/media.svg';
import accountsImg from './img/account.svg';


export class HSMetric extends HSCard {
    selected = false;
    value = null;

    static valueFormatters = {
        duration_hm(ms) {
            const totalMinutes = Math.round(Number(ms) / 60000);
            if (totalMinutes < 1) return '< 1 min';
            const hours = Math.floor(totalMinutes / 60);
            const mins = totalMinutes % 60;
            if (hours === 0) return `${mins} min${mins !== 1 ? 's' : ''}`;
            if (mins === 0) return `${hours} hr${hours !== 1 ? 's' : ''}`;
            return `${hours} hr${hours !== 1 ? 's' : ''}, ${mins} min${mins !== 1 ? 's' : ''}`;
        },
    };

    constructor() {
        super();
    }

    onLoad() {
        this.showLoading();
    }

    init(config) {
        super.init(config);
        this.title = this.config.title;
        this.footerTitle = this.config.footerTitle;
        this.valueSuffix = this.config.suffix;
        this.loadTemplate(template);
        this.loadStyles(styles);

        if (config.bgcolor == 'grey') {
            this.classList.add('hs-card-grey');
        } else {
            this.classList.add('hs-card-white');
        }

        if (config.h > 1) {
            const titleContainer = this.shadowRoot.querySelector('.value');
            titleContainer.classList.add('tall');
        }
        if (config.valueSize === 'small') {
            this.shadowRoot.querySelector('.value').classList.add('small');
        }
        if (config.layout === 'compact') {
            this.shadowRoot.querySelector('.container').classList.add('compact');
        }
        if (config.icon) {
            const iconContainer = this.shadowRoot.querySelector('.icon-container');
            const iconElement = document.createElement('img');
            if (config.icon == 'calls') {
                iconElement.src = callsImg;
            } else if (config.icon == 'tasks') {
                iconElement.src = tasksImg;
            } else if (config.icon == 'media') {
                iconElement.src = mediaImg;
            } else if (config.icon == 'accounts') {
                iconElement.src = accountsImg;
            }
            iconContainer.appendChild(iconElement);
            iconContainer.style.display = 'flex';
        }
        if (config.footerTitleTemplate || config.footerTitle) {
            const footerTitleElement = this.shadowRoot.querySelector('.footer');
            footerTitleElement.style.display = 'flex';
        }

        if (this.config.onclick) {
            this.onEvent('click', () => { 
                if (!this.selected) {
                    this.runAction(this.config.onclick, { tabGroup: this.config.tabGroup });
                } else {
                    Logger.debug("already selected, ignoring click");
                }
            });
        }
        this.reloadData();
    }

    setSelected(selected) {
        this.selected = selected;
        if (selected) {
            this.classList.remove('clickable');
            this.classList.add('selected');
        } else if (this.config.onclick) {
            this.classList.add('clickable');
            this.classList.remove('selected');
        }
    }

    setValue(value) {
        this.value = value;
        const formatter = this.config.valueFormatter && HSMetric.valueFormatters[this.config.valueFormatter];
        const display = formatter ? formatter(value) : value;
        this.shadowRoot.querySelector(".value").textContent = display;
    }

    setFooterValue(value) {
        this.shadowRoot.querySelector(".footerValue").textContent = value;
    }

    updateData(update) {
        Logger.debug("metric got an update from SSE: ", update);
        if (!this.config.field || !update.obj) { return; }
        const value = update.obj[this.config.field];
        if (value !== undefined) {
            this.setValue(value);
        }
    }

    async reloadData() {
        //if (window.location.href.includes('localhost')) { // for local development only } else {

        // clear displayed value while loading fresh data
        this.shadowRoot.querySelector('.value').textContent = '';

        if (this.config.footerTitleTemplate) {
            const footerText = Utils.evaluate(this.config.footerTitleTemplate, [ 'session' ], [ UserSession ]);
            const footerTitleElement = this.shadowRoot.querySelector('.footer-title');
            footerTitleElement.textContent = footerText;
        }

        // fetch the source data
        if (this.config.sources) {
            // multi-source mode: fetch all sources in parallel and evaluate a value expression
            const results = {};
            let hasData = false;
            await Promise.all(this.config.sources.map(async (s) => {
                const json = await this.getSourceData(s.src);
                if (json && json.length > 0) hasData = true;
                results[s.id] = json?.[0]?.[s.field] ?? 0;
            }));
            if (!hasData) {
                this.shadowRoot.querySelector('.value').textContent = '—';
            } else {
                const keys = Object.keys(results);
                const vals = keys.map(k => results[k]);
                const computed = Utils.evaluate(this.config.valueExpression, keys, vals);
                this.setValue(computed);
            }
        } else if (this.config.src && !(Array.isArray(this.config.src) && this.config.src.length === 0)) {
            const json = await this.getSourceData(this.config.src);
            if (!json || json.length === 0) {
                this.shadowRoot.querySelector('.value').textContent = '—';
            } else if (this.config.field) {
                this.setValue(json?.[0]?.[this.config.field] ?? 0);
            }
        }
        this.hideLoading();
    }

    getExportValues() {
        return [ { name: this.title, value: this.value } ];
    }
}
customElements.define('hs-metric', HSMetric);

